module.exports = __webpack_public_path__ + "static/img/logo.543dda09.png";